import React from "react";

/* eslint-disable max-len */
export default function AdminChannelIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} viewBox="0 0 30 30">
            <g data-name="\u30B0\u30EB\u30FC\u30D7 553">
                <g data-name="\u30B0\u30EB\u30FC\u30D7 537" fill="#9c9c9c">
                    <path
                        data-name="\u30D1\u30B9 8030"
                        d="M6.28 26.2a.8.8 0 01-.8-.8V6.28a.8.8 0 01.8-.8H25.4a.8.8 0 110 1.6H7.08V25.4a.8.8 0 01-.8.8z"
                        transform="translate(-40 -15) translate(.4 .4) translate(37.72 12.72)"
                    />
                    <path
                        data-name="\u524D\u9762\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u3067\u578B\u629C\u304D 1"
                        d="M-4038.331-322.762h-17.979a.571.571 0 01-.57-.57v-17.978a.571.571 0 01.57-.57h17.979a.57.57 0 01.569.57v17.978a.57.57 0 01-.569.57zm-11.111-13.688v8.257l5.67-4.129-5.67-4.129z"
                        transform="translate(-40 -15) translate(.4 .4) translate(4103.762 363.763)"
                    />
                </g>
            </g>
        </svg>
    );
}
